/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { styled, withStyled } from 'fierry/react';

import * as Hexagon from 'solis/type/point/hexagon';

import Svg from 'solis/react/element/icon.svg';


const getPolygonPoints = () =>
{
  const callback = ({ x, y }) => `${x},${y}`;

  return Hexagon.getPoints(Svg.size / 2).map(callback).join(' ');
};


const Hex = styled.polygon`

  fill: var(--icon-fill-normal);
  stroke: var(--icon-stroke-normal);
  stroke-width: var(--icon-stroke-width-normal);
`;


export default withStyled(props =>
(
  <Svg {...props}>
    <Hex points = {getPolygonPoints()}  />
  </Svg>
));
